<p>logs-digicod works!</p>
